if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.mainButton = this.form && this.form.querySelector('[name="add"]');
        if (!this.mainButton || !('IntersectionObserver' in window)) return;

        this.button = this.querySelector('.sticky-atc__button');
        this.priceElement = this.querySelector('.sticky-atc__price');
        this.variantElement = this.querySelector('.sticky-atc__variant');
        this.priceSource = document.getElementById(`price-${this.dataset.sectionId}`);
        this.picker = document.querySelector(
          `#variant-radios-${this.dataset.sectionId}, #variant-selects-${this.dataset.sectionId}`
        );
        this.mainButtonInView = true;

        this.syncButton();
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        if (this.priceSource && this.priceElement) {
          this.syncPrice();
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.priceSource, {
            attributes: true,
            attributeFilter: ['class'],
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        if (this.picker && this.variantElement) {
          this.onPickerChange = () => this.syncVariant();
          this.picker.addEventListener('change', this.onPickerChange);
        }

        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.mainButtonInView = entries[entries.length - 1].isIntersecting;
          this.update();
        });
        this.intersectionObserver.observe(this.mainButton);

        this.addEventListener('focusout', () => setTimeout(() => this.update()));
      }

      disconnectedCallback() {
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.priceObserver) this.priceObserver.disconnect();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.picker && this.onPickerChange) this.picker.removeEventListener('change', this.onPickerChange);
        document.body.classList.remove('sticky-atc-visible');
      }

      update() {
        const show = !this.mainButtonInView || this.contains(document.activeElement);
        if (this.hidden === !show) return;
        this.hidden = !show;
        document.body.classList.toggle('sticky-atc-visible', show);
      }

      syncButton() {
        const label = this.mainButton.querySelector('span') || this.mainButton;
        this.button.disabled = this.mainButton.hasAttribute('disabled');
        this.button.textContent = label.textContent.trim();
      }

      syncPrice() {
        const price = this.priceSource.querySelector('.price');
        if (!price) return;
        const current = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        if (current) this.priceElement.textContent = current.textContent.trim();
        this.priceElement.classList.toggle('visibility-hidden', this.priceSource.classList.contains('visibility-hidden'));
      }

      syncVariant() {
        const values = this.picker.tagName === 'VARIANT-RADIOS'
          ? Array.from(this.picker.querySelectorAll('fieldset'), (fieldset) => {
              const checked = fieldset.querySelector('input:checked');
              return checked ? checked.value : '';
            })
          : Array.from(this.picker.querySelectorAll('select'), (select) => select.value);
        this.variantElement.textContent = values.filter(Boolean).join(' / ');
      }
    }
  );
}
